<template>
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>
              <div>공지사항 등록 기본정보</div>
            </strong>
          </div>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <tbody class="">
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">등록일</label>
                    </td>
                      <td class="">
                        <span style="color:#ea0000; font-weight:bold; font-size:12px">* 등록일은 자동 등록됩니다.</span>
                        <b-row class="pt-sm-12">
                          <b-col sm="2"><b-form-input type="text" v-model="queryParams.reg_date" name="daterange" disabled /></b-col>
                        </b-row>
                      </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">노출여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group id="basicCustomUseyn" name="useyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useY" name="useyn" class="custom-control-input" v-model="queryParams.use_yn" value="Y" checked>
                            <label class="custom-control-label" for="useY">노출</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="useN" name="useyn" class="custom-control-input" v-model="queryParams.use_yn" value="N">
                            <label class="custom-control-label" for="useN">비노출</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                      <label class="col-form-label">공지여부</label>
                    </td>
                    <td class="">
                      <label class="col-form-label">
                        <b-form-radio-group id="basicCustomTopyn" name="topyn">
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="topY" name="topyn" class="custom-control-input" v-model="queryParams.top_yn" value="N" checked>
                            <label class="custom-control-label" for="topY">일반공지</label>
                          </div>
                          <div class="custom-control custom-radio custom-control-inline">
                            <input type="radio" id="topN" name="topyn" class="custom-control-input" v-model="queryParams.top_yn" value="Y">
                            <label class="custom-control-label" for="topN">상단공지</label>
                          </div>
                        </b-form-radio-group>
                      </label>
                    </td>
                  </tr>
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">제목</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col sm="7">
                            <b-form-input id="basicText" name="subject" type="text" v-model="queryParams.subject" v-validate="'required'" :class="{'is-invalid': errors.has('subject')}"></b-form-input>
                            <span v-show="errors.has('subject')" :class="{error: errors.has('subject')}">제목명은 필수 항목 입니다.</span>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>

                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                      <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">내용</label>
                      </td>
                      <td class="">
                        <vue-ckeditor v-model="queryParams.contents" :config="config" />
                      </td>
                  </tr>

<!--                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">-->
<!--                      <td width="150" style="background-color:#f1f1f1">-->
<!--                        <label class="col-form-label">내용</label>-->
<!--                      </td>-->
<!--                      <td class="">-->
<!--                        <textarea id="summernote"></textarea>-->
<!--                      </td>-->
<!--                  </tr>-->
                  <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0">
                    <td width="150" style="background-color:#f1f1f1">
                        <label class="col-form-label">첨부파일<br/>(PDF, IMAGE)</label>
                      </td>
                      <td class="">
                        <b-row class="pt-sm-12">
                          <b-col md="12" style="padding:13px">
                            <vue-dropzone ref="dropAttachmentFile" id="attachmentFile"
                              :options="dropzoneFileOptions"
                              @vdropzone-file-added="dropzoneAdded"
                              @vdropzone-success="dropzoneVsuccess"
                              @vdropzone-complete="dropzoneAfterComplete"
                              @vdropzone-upload-progress="dropzoneProgress"
                              :duplicateCheck="false">
                              <div class="dropzone-custom-content">
                                <i class="fas fa-cloud-upload-alt fa-3x"></i>
                                <h4 class="dropzone-custom-title mb-0 mt-3">Drag & Drop</h4>
                              </div>
                            </vue-dropzone>
                          </b-col>
                          <b-col md="8" style="margin-top:10px">
                            <draggable class="dragArea attachment"
                                        :options="{animation:300, handle:'.handle'}"
                                        :component-data="getComponentData()">
                                <li class="list-group-item" style="padding:0 0 10px 10px"
                                    v-for="item, index in queryParams.attachmentFileItems"
                                    :key="item.no">
                                    <span class="handle" >
                                        <i class="fa fa-bars fa-lg mt-4"></i>
                                    </span>
                                    <label class="col-form-label">
                                        <i class="fa fa-2x mt-1 bg-danger" v-bind:class="'fa-file-'+item.file_extensions+'-o'"></i> {{item.file_originalname}} <span>({{item.filesizeStr}})</span>
                                        <p class="fileurl" style="display:none">{{item.file_url}}</p>
                                    </label>
                                    <label class="col-form-label" style="float:right; margin:10px 10px 0 0"><a style="cursor:pointer; color:black" v-on:click="removeListFile"><i class="fa fa-remove"></i></a></label>
                                </li>
                            </draggable>
                          </b-col>
                        </b-row>
                      </td>
                  </tr>

                </tbody>
            </table>
          </div>
        </b-card>
      </b-col>
      <b-col md="12">
        <b-row style="margin-bottom:1.5em">
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            &nbsp;
          </b-col>
          <b-col sm="3" lg="4">
            <div style="float:right; width:70%">
              <b-row>
                <b-col md="4">
                </b-col>
                <b-col md="4">
                  <b-button variant="success" v-on:click="saveDrNotice()" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #248847; font-size:15px"><h5 style="margin-bottom:0px"><i class="fa fa-hand-o-up"></i> 등록</h5></b-button>
                </b-col>
                <b-col md="4">
                  <b-button variant="primary" style="color:#ffffff; border-radius:5px; cursor:pointer; width:100%; border:1px solid #187c9f; font-size:15px" v-bind:href="'#/customer/notice'"><i class="fa fa-list-ul"></i> 목록</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import Vue from 'vue';
import ko from 'vee-validate/dist/locale/ko.js'
import swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'
import draggable from "vuedraggable";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

import VueCkeditor from 'vue-ckeditor2';

const moment = require("moment");

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate, {
  locale: 'ko'
});

export default {
  components: {
    VueCkeditor,
    Multiselect,
    draggable,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      noticecode: '',
      pageOptions: [5, 10, 30, 50, 100],
      formtype: '',
      queryParams: {
        reg_date: moment().format('YYYY-MM-DD'),
        attachmentFileItems:[],
        use_yn: 'Y',
        top_yn: 'N',
      },
      calendarLocale: {
        "format": "YYYY-MM-DD",
        "separator": "~",
        "applyLabel": "적용",
        "cancelLabel": "취소",
        "fromLabel": "From",
        "toLabel": "To",
        "customRangeLabel": "Custom",
        "weekLabel": "W",
        "daysOfWeek": [
          "일", "월", "화", "수", "목", "금", "토"
        ],
        "monthNames": [
          "1월", "2월", "3월", "4월", "5월", "6월",
          "7월", "8월", "9월", "10월", "11월", "12월"
        ],
        "firstDay": 1
      },
      endDate: moment().format('YYYY-MM-DD'),
      startDate: moment().format('YYYY-MM-DD'),
      config: {
        toolbar:[
          { name: 'document', items: [ 'Source', 'Preview'] },
  	      { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
  	      { name: 'insert', items: ['Image', 'Table', 'HorizontalRule', 'SpecialChar', 'PageBreak'] },
  	      '-',
  	      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'CopyFormatting', 'RemoveFormat'] },
  	      { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'] },
  	      { name: 'links', items: ['Link', 'Unlink'] },
  	      '/',
  	      { name: 'styles', items: ['Styles', 'Format', 'Font', 'FontSize'] },
  	      { name: 'colors', items: ['TextColor', 'BGColor'] },
          { name: 'tools', items: [ 'Maximize' ] },
          { name: 'about', items: [ 'About' ] }
				],
        font_names: 'Noto Sans KR/Noto Sans KR,sans-serif;맑은 고딕/Malgun Gothic;굴림/Gulim;돋움/Dotum;바탕/Batang;궁서/Gungsuh;',
        filebrowserImageUploadUrl:'backend/ftpserver/ckeditImageUpload',
        uploadUrl: 'backend/ftpserver/ckeditImageUpload?command=QuickUpload&type=Files&responseType=json',
        height: 300,
        versionCheck: false,
        extraPlugins: 'tableresize'
      },
      enabled: true,
      dropzoneFileOptions: {
          url: 'backend/ftpserver/dropAndSingleFileUpload',
          autoProcessQueue: false,
          params: {
            files: "file",
            reportType: "notice",
            fileSubPath: "pdf_or_img",
          },
          thumbnailWidth: 150,
          //maxFilesize: 5.0,
          acceptedFiles: '.pdf,.jpg,.jpeg,.png',
          dictDefaultMessage: "<i class='fa fa-cloud-upload'></i> Drop files here to upload",
      },
    }
  },
  watch: {
  },
  mounted: function() {
    var token = sessionStorage.getItem("myToken");
    var self = this;
    self.formtype = self.$route.query.status;
    self.noticecode = self.$session.get('noticeCode');

    if(self.formtype == 'update'){
      self.getDrNoticeData(self.noticecode);
    }
  },
  methods: {
    // 메소드명 : getDrNoticeData(val)
    // ### 리포트 데이터 갱신 ###
    // 메소드 저장후 데이터 갱신용으로 사용
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  - val(해당 필드의 value 값을 가져옴)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.06.10  황경현   최초작성
    // *************************
    getDrNoticeData(noticecode) {
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.$http.get('/api/select/drNoticeData?access_token=' + token + '&noticecode=' + noticecode)
      .then((result) => {
        self.queryParams = result.data;
      })
    },
    // 메소드명 : saveDrNotice()
    // ### 공지사항 저장 ###
    // 공지사항 최초저장 및 수정
    // formtype 값이 insert or update 일때 if문 조건으로 실행
    //
    // 최초작성 : 2019.11.11
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.11.11  황경현   최초작성
    // *************************
    saveDrNotice() {
      var self = this;
      self.$validator.validateAll().then(success => {
        if (success) {
          var token = sessionStorage.getItem("myToken");
          self.queryParams.reg_id = self.$session.get('userId');

          if(self.queryParams.contents == ""){
            swal.fire({
              type: 'warning',
              title: '내용 부분은 필수로 작성해 주세요.',
              showConfirmButton: true,
            })
            return false;
          }

          var param = encodeURI(JSON.stringify(self.queryParams));
          var data = new FormData();
          data.append('noticeObj', param);

          if(self.formtype == 'insert'){
            self.$http.post('/api/insert/drNotice?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '공지사항이 등록되었습니다.',
                  showConfirmButton: false,
                  timer: 1500
                }).then(function() {
                    window.location = "#/customer/notice";
                });
            })
          }else if(self.formtype == 'update'){
            self.$http.post('/api/update/drNotice?access_token='+token, data, null)
              .then((result) => {
                swal.fire({
                  type: 'success',
                  title: '공지사항을 수정하였습니다.',
                  showConfirmButton: false,
                  timer: 1000
                }).then(function() {
                    window.location = "#/customer/notice";
                });
            })
          }
        }
      })
    },
    /**
    * 이미지 파일 업로드
    */
    uploadSummernoteImageFile(file, editor) {
      var self = this;
      var token = sessionStorage.getItem("myToken");
      var data = new FormData();
      data.append("file", file);

      self.$http.post('/ftpserver/editorImageUpload?access_token='+token, data, null)
      .then((result) => {
        $(editor).summernote('insertImage', result.data);
      })
    },

    //첨부파일 업로드 후 실행
    dropzoneAfterComplete(file) {
      // console.log(file);
    },
    // 메소드명 : dropzoneAdded()
    // ### 파일 10개 제한 ###
    // 파일이 10개 까지 제한으로 하는 메소드.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    dropzoneAdded (event){
      var self = this;
      setTimeout(function(){
          if(self.queryParams.attachmentFileItems.length >= 2){
            swal.fire({
              title: '파일 최대 업로드!',
              html: "파일은 최대 2개까지 업로드 가능 합니다.",
              type: 'warning',
            })
            self.$refs.dropAttachmentFile.removeAllFiles();
          }else{
            self.$refs.dropAttachmentFile.processQueue();
          }
      }, 100);
    },
    // 메소드명 : dropzoneVsuccess(file, response)
    // ### 드랍존 파일업로드 ###
    // 드랍존 파일다운로드 로서 성공시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - file(현재 파일)
    //  - response(다운로드후 발생하는 데이터)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    dropzoneVsuccess(file, response) {
      if(this.queryParams.attachmentFileItems.length == 0){
        response.file_sequence = 1;
        response.file_type_code = 'RPT_FILE_TYPE_1';
      }else{
        response.file_sequence = this.queryParams.attachmentFileItems.length+1;
        response.file_type_code = 'RPT_FILE_TYPE_1';
      }

      if(this.queryParams.attachmentFileItems.length >= 2){
        swal.fire({
          title: '파일 최대 업로드!',
          html: "파일은 최대 2개까지 업로드 가능 합니다.",
          type: 'warning',
        })
        this.$refs.dropAttachmentFile.removeAllFiles();
      }else{
        this.queryParams.attachmentFileItems.push(response);
      }
    },
    // 메소드명 : dropzoneProgress(file, totalBytes, totalBytesSent)
    // ### 드랍존 파일업로드 프로세스 ###
    // 드랍존 파일다운로드 프로세스 진행시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - file(현재 파일)
    //  - totalBytes(총 데이터 용량)
    //  - totalBytesSent(총 보낸 데이터 용량)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    dropzoneProgress(file, totalBytes, totalBytesSent){
      var dropOrg = this.$refs.dropAttachmentFile;
      setTimeout(function(){
          dropOrg.removeAllFiles();
      }, 2500);
    },

// 메소드명 : removeListFile(e)
    // ### 드랍앤드래그 리스트 삭제 ###
    // 드랍앤드래그 삭제시 리스트 순서 정렬과 해당데이터 갱신
    //
    // 최초작성 : 2016.05.31
    // 파라미터 :
    //  - e(이벤트 발생시)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    removeListFile(e) {
      var fileLists = [];
      var className = e.target.parentNode.parentNode.parentNode.parentNode.classList[1];
      var targetFileUrl = e.target.parentNode.parentNode.parentNode.children[1].lastChild.innerText;
      if(className == "attachment"){
        fileLists = this.queryParams.attachmentFileItems;
      }else if(className == "preview"){
        fileLists = this.queryParams.previewFileItems;
      }

      fileLists.forEach(function (el, idx, arr){
        if(el.file_url == $.trim(targetFileUrl)){
          fileLists.splice(idx, 1);
        }
      });
      fileLists.forEach(function (el, idx, arr){
        el.file_sequence = (idx+1);
      });

      if(className == "attachment"){
        this.queryParams.attachmentFileItems = fileLists;
      }else if(className == "preview"){
        this.queryParams.previewFileItems = fileLists;
      }
    },

    // 메소드명 : handleChange()
    // ### 파일 10개 제한 ###
    // 드래그 드랍 이동시 해당 파일의 순서를 재정렬 한다.
    //
    // 최초작성 : 2016.06.10
    // 파라미터 :
    //  -
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2016.06.10  황경현   최초작성
    // *************************
    handleChange(e) {
      var eventFiles = [];
      if(e.target.classList[1] == "attachment"){
        eventFiles = this.queryParams.attachmentFileItems;
      }else if(e.target.classList[1] == "preview"){
        eventFiles = this.queryParams.previewFileItems;
      }
      var childNode = e.target.childNodes;
      var childNodeLen = e.target.childNodes.length;

      for (var i = 0; i < eventFiles.length; i ++){
        for (var j = 0; j < childNodeLen; j ++){
          var dataFileUrl = childNode[j].children[1].lastChild.innerText;
          if(eventFiles[i].file_url == dataFileUrl){
            eventFiles[i].file_sequence = (j+1);
          }
        }
      }

      if(e.target.classList[1] == "attachment"){
        this.queryParams.attachmentFileItems = eventFiles;
      }else if(e.target.classList[1] == "preview"){
        this.queryParams.previewFileItems = eventFiles;
      }
    },
    inputChanged(value) {
      this.activeNames = value;
    },
    // 메소드명 : getComponentData()
    // ### 드랍앤드래그 리스트 이동 ###
    // 드랍앤드래그 이동시 이벤트 발생.
    //
    // 최초작성 : 2016.05.31
    // 파라미터 : 없음
    // *************************
    // ## 코드 히스토리 ##
    //    날짜    작성자     수정내용
    // 2019.05.31  황경현   최초작성
    // *************************
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    },
  }
}

</script>
<style lang="css" scoped>
.buttons {
  margin-top: 35px;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.p20{
    padding:20px
}

.normal {
    background-color: grey;
}

.dragArea{
    min-height: 10px;
}

.sortable-chosen {
    opacity: 0.7;
    background-color:#dcdcdc;
}

.sortable-ghost {
    background-color:#dcdcdc;
}
.handle {
    padding: 5px;
    margin-right: 10px;
    border: solid #000 1px;
    cursor: move;
}

span.error {
  color: #9F3A38;
}


#VueTables__search_UBume {
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 4px;
  cursor: pointer;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/customer/NoticeForm.vue